// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"235":"864b4ec5d1ce673e09f6866e3e400295","531":"bde7d432713268d9f295a44a9a0209c4","591":"eeb946bcb69ca8d3dac049c271ac23dc"}[chunkId] + ".js";
};